import { required } from "vuelidate/lib/validators";
import { Model } from "./Model";
import { Tipo, TipoNoValidation } from "./Tipo";
import { Endereco, EnderecoValidation, EnderecoNoValidation } from "./Endereco";
import { telephone } from "./validators";

class Contabilista extends Model {
  constructor() {
    super();
    this.nome = "";
    this.crc = "";
    this.cpf = "";
    this.rg = "";
    this.rgExpedidor = "";
    this.cnpj = "";
    this.email = "";
    this.fone = "";
    this.tipo = new Tipo();
    this.endereco = new Endereco();
  }
}

const ContabilistaValidation = {
  nome: {
    required,
  },
  crc: {
    required,
  },
  email: {
    required,
  },
  fone: {
    required,
    telephone,
  },
  endereco: EnderecoValidation,
};

const ContabilistaNoValidation = {
  nome: {},
  crc: {},
  email: {},
  fone: {},
  endereco: EnderecoNoValidation,
  tipo: TipoNoValidation,
};

export { Contabilista, ContabilistaValidation, ContabilistaNoValidation };
